<div class="flex">
  <div
    class="flex flex-col relative rounded-{{
      rounded
    }} w-10 h-10 min-w-10 bg-gray-200 justify-center items-center gt-xs:mr-4 mr-2"
    *ngIf="img">
    <img class="w-10 rounded-full object-cover" [ngSrc]="img" alt="" fill />
  </div>
  <div class="grid xs:max-w-[75%] truncate">
    <span class="font-medium {{ classTitle }}">{{ title }}</span>
    <small>{{ subtitle }}</small>
  </div>
</div>
